import { SwitchAccountOutlined } from '@mui/icons-material';
import { Badge } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';

import { useSteps } from 'containers/OnboardingTracker/useSteps';

export const useStyles = makeStyles({
  badge: {
    color: 'white !important',
  },
});

export const OnboardingStatus = () => {
  const steps = useSteps();
  const classes = useStyles();

  const pendingStepsCount = steps.filter((step) => !step.checked && step.enabled).length;

  if (steps.length === 0) {
    return null;
  }

  const icon = <SwitchAccountOutlined width={24} height={24} />;
  return (
    <Link to="/onboarding" title="Onboarding overview" style={{ marginRight: 24 }}>
      <Badge badgeContent={pendingStepsCount} color="warning" classes={classes}>
        {icon}
      </Badge>
    </Link>
  );
};
